<template>
  <v-card :loading="loading" v-bind="$attrs" v-on="$listeners">
    <v-card-title class="headline">{{ title }}</v-card-title>

    <v-card-subtitle>
      <span>{{ subtitle }}</span>
    </v-card-subtitle>
    <v-card-text class="display-2 text-center" v-if="!loading">
      {{ count | toNumber }}
    </v-card-text>
    <v-card-actions style="height: 55px">
      <v-spacer></v-spacer>
      <v-btn color="primary" :to="{ name: 'participantManagement', query: { active: 1 } }">
        Manage
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AdminParticipantsWidget",
  props: {
    title: {
      type: String,
      default: "Active Participants"
    },
    subtitle: {
      type: String,
      default: ""
    },
    filters: { type: Object, required: false, default: () => ({}) }
  },
  data() {
    return {
      count: 0,
      loading: true
    };
  },
  mounted() {
    this.fetchData();
  },

  computed: {
    ...mapGetters(["selectedProgram", "selectedClient"])
  },
  methods: {
    fetchData() {
      this.loading = true;

      let searchForm = { ...this.filters };

      this.$api
        .post("/api/participants/search?size=1", searchForm)
        .then(({ data }) => {
          this.count = data.totalElements;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
